<template>
  <div class="container">
    <!-- content -->
    <ul>
      <li>
        <h3>1、下载总仓盘点单</h3>
        <div>
          <span>
            <label><i>*</i>项目名称：</label>
            <a-select
              style="width:200px"
              showSearch
              :filterOption="filterOption"
              optionFilterProp="children"
              v-model="project_id"
            >
              <a-select-option
                v-for="(item, i) in proList"
                :key="i"
                :value="item.id"
                >{{ item.project_name }}</a-select-option
              >
            </a-select>
          </span>
          <span class="submitStyle">
            <a-button type="primary" @click="download">下载</a-button>
          </span>
        </div>
      </li>
      <li>
        <h3>2、上传总仓盘点数据</h3>
        <div>
          <span>
            <label><i>*</i>项目名称：</label>
            <a-select
              v-model="project_id_up"
              style="width:200px"
              showSearch
              :filterOption="filterOption"
              optionFilterProp="children"
            >
              <a-select-option
                v-for="(item, i) in proList"
                :key="i"
                :value="item.id"
                >{{ item.project_name }}</a-select-option
              >
            </a-select>
          </span>
          <span>
            <label><i>*</i>盘点日期：</label>
            <a-date-picker @change="onChange" />
          </span>
          <span>
            <label><i>*</i>盘点表：</label>
            <input type="file" @change="excelData" />
          </span>
          <span class="submitStyle">
            <a-button type="primary" @click="upData">上传</a-button>
          </span>
        </div>
      </li>
    </ul>
    <!-- content end -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      proList: [],
      project_id: "",
      check_date: "",
      checkFile: "",
      project_id_up: ""
    };
  },
  mounted() {
    this.getPro(); //获取项目列表
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChange(date, dateString) {
      this.check_date = dateString;
    },
    download() {
      if (this.project_id != "") {
        window.location.href =
          this.httpsBasic.url +
          this.httpsBasic.equipment +
          "Project_check/downloadProjectCheckTpl?token=" +
          window.localStorage.getItem("xnwfPcToken") +
          "&project_id=" +
          this.project_id;
      } else {
        this.$message.error("请选择项目!");
      }
    },
    verify() {
      let fls = true;
      if (this.project_id_up == "") {
        fls = false;
        this.$message.error("请选择项目！");
        return false;
      }
      if (this.check_date == "") {
        fls = false;
        this.$message.error("请选择日期！");
        return false;
      }
      if (this.checkFile == "") {
        fls = false;
        this.$message.error("请选择表格！");
        return false;
      }
      return fls;
    },
    upData() {
      let fls = this.verify();
      if (fls) {
        let url =
          this.httpsBasic.url +
          this.httpsBasic.equipment +
          "Project_check/upload";
        let formData = new FormData();
        formData.append("excel", this.checkFile);
        formData.append("token", window.localStorage.getItem("xnwfPcToken"));
        formData.append("check_date", this.check_date);
        formData.append("project_id", this.project_id_up);
        let config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };
        // console.log(params);
        axios.post(url, formData, config).then(res => {
          if (res.data.code == 200) {
            this.$emit("hideInAdd", true);
            this.$message.success("提交成功");
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    excelData(e) {
      this.checkFile = e.target.files[0];
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.container {
  padding: 30px 2%;
  li {
    margin-bottom: 60px;
    h3 {
      margin-bottom: 20px;
    }
    > div {
      > span {
        display: block;
        margin-bottom: 20px;
      }
      i {
        display: inline-block;
        font-style: normal;
        color: red;
        margin-right: 4px;
      }
      .submitStyle {
        margin-left: 70px;
        margin-top: 20px;
      }
    }
  }
}
</style>
